import { useQuery } from '@tanstack/react-query';

import { getSingleClinicOrder } from 'app/services/clinic-order';

export default function useClinicOrder(orderId) {
  const queryKey = ['clinicOrder', orderId];

  const {
    data: clinicOrder,
    isInitialLoading,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: () => getSingleClinicOrder({ orderId }),
    enabled: Boolean(orderId),
    refetchOnWindowFocus: false,
    cacheTime: 60000,
  });

  return { clinicOrder, isInitialLoading, queryKey, refetch };
}
